<button
  [disabled]="disabled"
  (click)="colorClick.emit()"
  class="btn p-0"
  [style.background]="color"
  [class.active]="active"
></button>
